import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { ServiceOrder, ServiceOrderStatus } from '../serviceOrder.types';

type ServiceOrderSidebarFooterProps = {
    serviceOrder: ServiceOrder;
    handleArchiveServiceOrder: () => void;
    handleSaveServiceOrder: () => void;
    onClose: () => void;
    isRequestPending: boolean;
};

export const ServiceOrderSidebarFooter = (props: ServiceOrderSidebarFooterProps) => {
    const hasActionButton = !props.serviceOrder.isArchived;
    const isArchiveButton =
        props.serviceOrder.isFinalized || props.serviceOrder.status === ServiceOrderStatus.CANCELLED;

    const { labelId, iconName, ...otherButtonProps } = isArchiveButton
        ? {
              labelId: 'outboundPortal.serviceOrder.button.archive',
              bsStyle: Button.DANGER,
              variant: Button.VARIANT_OUTLINE,
              iconName: 'rioglyph-folder-closed',
              onClick: props.handleArchiveServiceOrder,
          }
        : {
              labelId: 'outboundPortal.serviceOrder.button.save',
              bsStyle: Button.PRIMARY,
              iconName: 'rioglyph-ok',
              onClick: props.handleSaveServiceOrder,
          };

    return (
        <div className="display-flex gap-10 flex-row-reverse">
            <Button className={Button.DEFAULT} onClick={props.onClose}>
                <FormattedMessage id="outboundPortal.close" />
            </Button>
            {hasActionButton && (
                <Button
                    {...otherButtonProps}
                    className={classNames({ 'btn-loading': props.isRequestPending })}
                    iconName={!props.isRequestPending ? iconName : undefined}
                >
                    <FormattedMessage id={labelId} />
                </Button>
            )}
        </div>
    );
};
